import { _ as _objectWithoutPropertiesLoose, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import '../Box/Box.js';
import 'react';
import 'reakit-utils/useLiveRef';
import 'reakit-utils/isSelfTarget';
import 'reakit-utils/useIsomorphicEffect';
import 'reakit-utils/useSealedState';
import '../Id/IdProvider.js';
import '../Id/IdState.js';
import '../Disclosure/DisclosureState.js';
import '../Disclosure/DisclosureContent.js';
import 'react-dom';
import '../Portal/Portal.js';
import '../Dialog/DialogState.js';
import '../DialogBackdropContext-2db2c622.js';
import { useDialogBackdrop } from '../Dialog/DialogBackdrop.js';
import '@popperjs/core';
import { usePopoverState } from './PopoverState.js';

var usePopoverBackdrop = createHook({
  name: "PopoverBackdrop",
  compose: useDialogBackdrop,
  useState: usePopoverState,
  useOptions: function useOptions(_ref) {
    var _ref$modal = _ref.modal,
        modal = _ref$modal === void 0 ? false : _ref$modal,
        options = _objectWithoutPropertiesLoose(_ref, ["modal"]);

    return _objectSpread2({
      modal: modal
    }, options);
  }
});
var PopoverBackdrop = createComponent({
  as: "div",
  memo: true,
  useHook: usePopoverBackdrop
});

export { PopoverBackdrop, usePopoverBackdrop };
